/* ==========================================================
   LA VOCE DI MENU DELLA SEZIONE IN CUI CI SI TROVA

   Chiesto il 12 agosto 2026: stando su /collections/kids, la voce KIDS
   della barra deve essere azzurra, non nera. Vale per la barra del
   desktop e per il cassetto del telefono.

   PERCHE' NON BASTA IL CSS
   Il tema non scrive nessun aria-current sulle voci, e gli indirizzi non
   coincidono con la pagina: la voce E-BIKE 2027 punta a
   /collections/cube-e-bike/ebike-2027 mentre la collezione e'
   /collections/cube-e-bike. Non c'e' niente su cui agganciare un
   selettore, quindi la voce va marcata da qui e il colore lo mette
   assets/cube-header.css sulla classe cube-voce-attiva.

   PERCHE' NON C'E' UNA TABELLA DI CORRISPONDENZE
   La sezione a cui appartiene una collezione e' gia' scritta nel menu:
   il pannello di E-BIKE 2027 contiene /collections/e-mtb-full, quello di
   BIKE 2027 contiene /collections/mtb-full, e cosi' via. Si guarda li'
   invece di tenere un elenco a parte, che andrebbe aggiornato a mano a
   ogni ritocco del menu e si scollerebbe al primo che se ne dimentica.

   PERCHE' STA NEL LAYOUT E NON NEL BLOCCO DELLA TESTATA
   Stesso motivo di cube-megamenu.js, spiegato in layout/theme.liquid: il
   blocco Liquid della testata vive dentro #header-group, che il tema
   ricostruisce, e uno <script> li' dentro non verrebbe mai eseguito.

   COSA NON FA
   Sulle pagine prodotto non accende niente: l'indirizzo e' /products/...
   e non dice a quale sezione appartiene. Per farlo servirebbe leggere le
   collezioni del prodotto, che e' un'altra cosa e non e' stata chiesta.
   ========================================================== */

(function () {
  'use strict';

  var CLASSE = 'cube-voce-attiva';

  /* ---------- da indirizzo a chiave confrontabile ----------
     Tre normalizzazioni, tutte necessarie:

     1. via parametri e ancora: /collections/kids?sort=x -> /collections/kids
     2. via la barra finale, altrimenti /collections/kids/ e
        /collections/kids sarebbero due cose diverse
     3. /collections/<handle>/<tag> -> /collections/<handle>
        E' quella che fa incontrare la voce E-BIKE 2027
        (/collections/cube-e-bike/ebike-2027) con la sua collezione
        (/collections/cube-e-bike). Senza, non si troverebbero mai.

     Il prefisso di lingua viene tolto prima del confronto leggendo
     Shopify.routes.root: oggi il negozio e' solo italiano e la radice e'
     "/", ma se un domani ne venisse aggiunta una il taglio del punto 3
     continuerebbe a funzionare. */

  function chiave(indirizzo) {
    if (!indirizzo) return '';

    var p = indirizzo.split('?')[0].split('#')[0];
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);

    var radice = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    radice = radice.replace(/\/$/, '');
    if (radice && p.indexOf(radice) === 0) p = p.slice(radice.length) || '/';

    var m = p.match(/^\/collections\/([^\/]+)/);
    return m ? '/collections/' + m[1] : p;
  }

  /* Indirizzi che non identificano nessuna sezione. Senza questa
     esclusione, in homepage si accenderebbero "Usato" e
     "Componenti/Ricambi", che oggi puntano a "/" - e nei pannelli ci sono
     decine di voci con href="#", che si accenderebbero tutte insieme. */

  function inutile(k) {
    return !k || k === '/' || k === '#' || k === '';
  }

  function contiene(ambito, qui) {
    var link = ambito.querySelectorAll('a[href]');
    for (var i = 0; i < link.length; i++) {
      if (chiave(link[i].getAttribute('href')) === qui) return true;
    }
    return false;
  }

  /* ---------- chi si accende ----------
     Due passaggi, e l'ordine conta. Prima si cerca la voce il cui PROPRIO
     indirizzo e' la pagina in cui siamo; solo se non c'e' si guarda dentro
     i pannelli.

     Serve perche' la stessa collezione puo' comparire in piu' sezioni:
     /collections/kids sta sia sotto KIDS sia dentro il pannello di BIKE
     2027, e senza questa precedenza si accenderebbe BIKE, che viene prima
     nella barra. */

  function scegli(gruppi, qui) {
    var i;
    for (i = 0; i < gruppi.length; i++) {
      if (chiave(gruppi[i].href) === qui) return gruppi[i].voce;
    }
    for (i = 0; i < gruppi.length; i++) {
      if (contiene(gruppi[i].ambito, qui)) return gruppi[i].voce;
    }
    return null;
  }

  function applica(gruppi, qui) {
    var scelta = inutile(qui) ? null : scegli(gruppi, qui);
    for (var i = 0; i < gruppi.length; i++) {
      gruppi[i].voce.classList.toggle(CLASSE, gruppi[i].voce === scelta);
    }
  }

  /* ---------- i due menu ---------- */

  function barraDesktop() {
    var gruppi = [];
    var voci = document.querySelectorAll('.header__row--bottom .menu-list__list-item');
    for (var i = 0; i < voci.length; i++) {
      /* dentro ogni <li> c'e' un solo .menu-list__link, il suo: le voci
         del pannello portano la classe .mega-menu__link (verificato) */
      var link = voci[i].querySelector('.menu-list__link');
      if (!link || !link.getAttribute('href')) continue;
      gruppi.push({ voce: link, href: link.getAttribute('href'), ambito: voci[i] });
    }
    return gruppi;
  }

  function cassettoTelefono() {
    var gruppi = [];
    /* la voce di primo livello e' un <summary> senza indirizzo dentro un
       <details>: l'indirizzo lo prendono i figli, quindi qui l'ambito e'
       il <details> e la voce da accendere e' il <summary> */
    var titoli = document.querySelectorAll('.menu-drawer__menu-item--mainlist');
    for (var i = 0; i < titoli.length; i++) {
      var t = titoli[i];
      gruppi.push({
        voce: t,
        href: t.getAttribute('href'),
        ambito: t.closest('.menu-drawer__menu-container') || t
      });
    }
    return gruppi;
  }

  /* ---------- avvio ----------
     La testata viene ricostruita dal tema dopo essere stata disegnata (la
     stessa trappola documentata in cube-megamenu.js), e il cassetto del
     telefono compare solo quando lo si apre. Percio' l'osservatore non si
     stacca mai: rimarca la voce ogni volta che il markup cambia.

     Si osserva solo childList, non gli attributi: aggiungere una classe e'
     una modifica di attributo e rientrerebbe qui in cerchio. */

  var inCoda = false;

  function segna() {
    var qui = chiave(location.pathname);
    applica(barraDesktop(), qui);
    applica(cassettoTelefono(), qui);
  }

  function segnaPiuTardi() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      segna();
    });
  }

  function avvia() {
    segna();
    if (window.MutationObserver) {
      var radice = document.getElementById('header-group') || document.body;
      new MutationObserver(segnaPiuTardi).observe(radice, { childList: true, subtree: true });
    }
    /* il tema cambia pagina senza ricaricare quando le transizioni sono
       accese: allora location.pathname cambia da solo e va rifatto il conto */
    window.addEventListener('popstate', segnaPiuTardi);
    document.addEventListener('shopify:section:load', segnaPiuTardi);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
